import React from 'react'
import Badge from '../../../../components/ui/badge'
import Tooltip from '../../../../components/ui/tooltip'

export const SpeakerBadge: React.FC<{ host: string; colorClass?: string; onToggleHost?: () => void; disabled?: boolean; nextHostLabel?: string }> = ({ host, colorClass, onToggleHost, disabled, nextHostLabel }) => {
  // Generate a consistent color variant based on the host name (fallback)
  const getHostColorVariant = (hostName: string): 'info' | 'brand' | 'purple' | 'pink' | 'indigo' | 'success' => {
    const variants: ('info' | 'brand' | 'purple' | 'pink' | 'indigo' | 'success')[] = [
      'info',
      'brand',
      'purple',
      'pink',
      'indigo',
      'success',
    ]
    let hash = 0
    for (let i = 0; i < hostName.length; i++) {
      hash = hostName.charCodeAt(i) + ((hash << 5) - hash)
    }
    return variants[Math.abs(hash) % variants.length]
  }

  // Render only name part before '-'
  const displayHost = host.split('-')[0].trim()

  // If custom colorClass is provided, use the Badge with custom styling
  if (colorClass) {
    return (
      onToggleHost ? (
        <Tooltip content={`Change the speaker to ${nextHostLabel || 'other host'}`} side="top" disabled={disabled}>
          <button
            type="button"
            onClick={onToggleHost}
            disabled={disabled}
            aria-label={nextHostLabel ? `${host}. Switch to ${nextHostLabel}` : `Host ${host}`}
            title={nextHostLabel ? `Switch to ${nextHostLabel}` : host}
            className={`inline-flex items-center rounded-lg px-2.5 py-1 text-xs font-medium ring-1 ring-inset transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1 ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:brightness-105'} ${colorClass}`}
          >
            {displayHost}
          </button>
        </Tooltip>
      ) : (
        <span
          className={`inline-flex items-center rounded-lg px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${colorClass}`}
          title={host}
        >
          {displayHost}
        </span>
      )
    )
  }

  // Otherwise use the unified Badge component with computed variant
  const variant = getHostColorVariant(host)
  const variantClass = `variant-${variant}`

  return (
    onToggleHost ? (
      <Tooltip content={`Change the speaker to ${nextHostLabel || 'other host'}`} side="top" disabled={disabled}>
        <button
          type="button"
          onClick={onToggleHost}
          disabled={disabled}
          aria-label={nextHostLabel ? `${host}. Switch to ${nextHostLabel}` : `Host ${host}`}
          title={nextHostLabel ? `Switch to ${nextHostLabel}` : host}
          className={`cursor-pointer rounded-lg px-2.5 py-1 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1 ring-1 ring-inset ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:bg-black/5'} ${variantClass}`}
        >
          {displayHost}
        </button>
      </Tooltip>
    ) : (
      <Badge
        variant={variant}
        size="sm"
        className="rounded-lg px-2.5 py-1"
        title={host}
      >
        {displayHost}
      </Badge>
    )
  )
}
